import axios from "axios"
import { attachBearerToken, handleSessionExpiry } from './authSession';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://api.fleetnexis.datadove.tech';

const api = axios.create({
    baseURL: API_BASE_URL
  });

api.interceptors.request.use(
  (config) => attachBearerToken(config),
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';

    if (status === 401) {
      handleSessionExpiry(requestUrl);
    }

    return Promise.reject(error);
  },
);

  export default api
